import styles from "./TermsAndConditions.module.css";

const MainTandC = () => {
  return (
    <>
      <p>
        We/I confirm and agree that my/our account(s) and all transactions
        between me/us ("the Customer", "I", or "me", or "us" or "we") and The
        Alternative Bank transacting through its Non-Interest Banking window
        ("the Bank") shall be governed by the Conditions specified below and/or
        the terms of any specific agreement between me/us and the Bank or where
        not regulated by either the conditions or such agreement, by customary
        banking practices in Nigeria: Islamic Banking practices.{" "}
      </p>
      <ol className={styles.numberedList}>
        <li>
          The Bank shall neither open nor permit the operation of the requested
          account(s) unless and until it has received the required supporting
          documents for the account, a list of which has been provided to us and
          is included with this application form.
        </li>
        <li>
          The Bank is hereby authorized to undertake all "Know Your Customer"
          (KYC) procedures specified by applicable law and/or regulations and/or
          Bank policies including the confirmation of our details and legal
          status at the appropriate government registry.
        </li>
        <li>
          Advisory Committee of Experts: This product has been reviewed and
          approved by the members of the Advisory Committee of Experts (ACE) of
          The Alternative Bank.
        </li>
        <li>
          Deposits: Deposit accounts are based on three NIB (Non-interest
          banking) principles:
          <ul className={styles.eligibilityList}>
            <li>
              <strong>Transactional accounts</strong> are based on 'Qardh'
              (where the bank is borrowing your funds and is entitled to pay on
              demand).
            </li>
            <li>
              <strong>Profit Share Accounts</strong> are based on the principle
              of 'Mudarabah' (Partnership) contract (where the Bank acts as the
              manager of funds and depositors are entitled to profit share on
              the amount deposited based on an agreed ratio).
            </li>
            <li>
              <strong>Term deposit investment account</strong> is based on the
              'Wakala' (fee-based) mode where the customer appoints the bank as
              an agent to buy and sell permissible commodities on its behalf for
              a profit.
            </li>
          </ul>
        </li>
        <li>
          Profits: Profits will not be earned on all 'Qardh' accounts i.e.
          current, savings, Kia-Kia accounts. Profit will be shared at a ratio
          agreed at initiation of profit share accounts where 'Mudarabah'
          (partnership) is used. These accounts include Mudarabah Savings,
          Pilgrimage, Trust and Profit Share Investment Accounts. <br />
          <br />
          For the Mudarabah Savings Account, profit shall be calculated based on
          the Customer’s average account balance and distributed monthly,
          subject to the applicable product terms. The Bank and the Customer
          shall share the profit generated from the Mudarabah investment
          portfolio based on the applicable Profit-Sharing Ratio (PSR). The
          applicable PSR is 80%Bank/20% customer and may be reviewed
          periodically, or in accordance with applicable guidelines,
          regulations, or policy.
          <br />
          <br />
          For the Mudarabah Savings Account, profit eligibility is subject to
          the Customer not making more than four (4) withdrawals within a month.
          Profit is not guaranteed and is dependent on the actual performance of
          the Mudarabah investment portfolio.
          {/* In 'Wakala' (fee-based) deposits,
          the bank will take an agreed fee which is agreed at the inception of
          the deposit. The Bank may impose or change the minimum balance
          requirements for my/our account(s) or alter the applicable interest
          rate(s) for the charges relating to such account(s) or any of them,
          with notice to me/us. The Bank is authorized, where the balance
          standing to the credit of my/our account(s) is below the required
          minimum balance, to either amend the rate(s) of interest payable or
          close the account(s). */}
        </li>
        <li>
          The Bank shall, in addition to any right of set-off or similar right
          prescribed by law, be entitled without notice to combine and
          consolidate all or any of my/our Accounts with the Bank (without any
          liabilities to the Bank) and/or to set off or transfer any or all
          amounts owed by me/us or either of us or a related party to the Bank
          against any and all money which the Bank may hold for my/our account
          or any other credit, be it cash, cheques, valuables, deposits,
          securities, negotiable instruments or other assets belonging to me/us
          whether held in current or deposit account or otherwise and whether in
          Naira or any other currency (hereinafter referred to as: foreign
          currency).
        </li>
        <li>
          The Bank shall be entitled to retain and not repay any amount
          whatsoever that it owes to me/us or which is held on my/our behalf
          until all amounts owed by me/us or the related party to the Bank have
          been repaid or discharged in full and, for so long as such amounts
          have not been discharged or repaid in full, the Bank shall be entitled
          to appropriate any amounts so owed to me/us or held on my/our behalf
          in or towards the payment and discharge of the amounts owed by me/us
          or either of us or the related party to the Bank.
        </li>
        <li>
          When effecting any set-off, the Bank shall be entitled at its absolute
          discretion, with or without notice to us, to convert any Naira or
          foreign currency into the currency in which the amount owed was
          incurred at the applicable exchange rate for the currencies in
          question prevailing in Nigeria at the time of such conversion.
        </li>
        <li>
          I/We shall be responsible for all costs, expenses, and liabilities
          arising from the purchase, retention, and sale of investments made on
          our behalf by the Bank, which include but are not limited to all
          taxes, statutory fees, duties, and levies.
        </li>
        <li>
          The Bank's statement(s) on my/our account(s) shall be sent to my email
          address indicated overleaf and from time to time such other
          information relevant to the account may be sent to the mobile
          telephone number indicated overleaf. Any disagreements with entries on
          my/our Bank Statement(s) shall be made by me/us in writing and
          delivered to the Bank within 15 days of the print date indicated
          thereon, failing which the Bank shall consider the statement rendered
          to be correct.
        </li>
        <li>
          Any change in my/our particulars indicated overleaf shall immediately
          be communicated to The Alternative Bank Plc at the branch where the
          account was opened.
        </li>
        <li>
          My/our attention has been drawn to the necessity of safeguarding
          my/our cheque book and other Bank's instruments so that unauthorized
          persons are unable to gain access to them, and to the fact that
          neglect of this precaution may be grounds for any consequential loss
          being charged to my/our account.
        </li>
        <li>
          To comply with all rules and regulations issued by the Bank governing
          the use of electronic banking services which the Bank may from time to
          time offer and provide to me/us in order to ensure banking
          convenience.
        </li>
        <li>
          In consideration of the Bank, its employees, or agents agreeing to
          accept and act upon oral or text instruction, communications, and
          documents received by facsimile electronic mail, or telexes or letters
          issued according to my/our mandate and unaccompanied by my/our cheque,
          I/We hereby irrevocably undertake to indemnify the bank and hold it
          harmless from and against all costs (including without limitation
          legal fees and expenses), claims, losses, liabilities, damages,
          actions, and proceedings whatsoever that the Bank may suffer or incur,
          or that may arise as a result of the Bank debiting my/our account
          immediately with all sums paid by the bank in respect of such
          instructions, and with all sums of money whatsoever earnings on money,
          costs, charges, and expenses which the Bank may incur as a result of
          complying with the instruction as aforesaid. Furthermore, I/we hereby
          irrevocably release the Bank from all liability in the event that any
          oral or text instructions untested telex or facsimile transmission or
          letter or other such communication is not received or mutilated or
          altered illegible or interrupted, duplicated, incomplete, unauthorized
          or delayed for any reason.
        </li>
        <li>
          Where the Bank in the absence of any previous agreement as to the rate
          of fees and costs and charges that will apply if my/our accounts or
          any of them become overdrawn in its absolute discretion allows us to
          make any drawing that results in my/our account(s) or any of them
          becoming overdrawn, the Bank shall be entitled to charge such a rate
          of interest and impose such charges as, in its absolute discretion, it
          considers appropriate in the circumstances, and I/We agree to pay such
          interest and charges to the Bank on demand.
        </li>
        <li>
          I/We agree that where I/We give any instruction for a payment that in
          aggregate exceeds the amount standing to the credit of my/our accounts
          against which payment is to be made, the Bank reserves the right to
          decline to carry out such instruction or where there is more than one
          transaction to select the transaction that shall be executed without
          reference to the date of dispatch or time of receipt of my/our
          instructions. If the Bank in its discretion makes any such payment for
          which our/my account is not funded, we/I confirm our obligation to
          repay the Bank, whether or not the Bank makes a demand, any
          outstanding sum in addition to charges and profit accrued thereon.
        </li>
        <li>
          Where I/We maintain a credit account with the Bank in any foreign
          currency, the credit balance of such an account may be held by the
          Bank with any bank or financial institution it considers first-rate
          located in any country in which such foreign currency is legal tender.
          Such credit balance will accordingly be subject to all laws and
          applicable regulations in Nigeria and in the country in which such
          credit balance is held, and the Bank shall not be held liable if the
          credit balance or any part thereof becomes unavailable as a result of
          any of the laws and regulations to which such credit balance is
          subject.
        </li>
        <li>
          Where any un-cleared effects credited to my/our account(s) by the Bank
          are subsequently dishonored and/or the Bank for any reason is required
          to pay to the paying banker or any other party all or any part of any
          amount credited to our account, the Bank will be entitled to debit
          my/our account(s) with the amount of such un-cleared effects and/or
          repaid amount plus accrued interest and applicable bank charges.
        </li>
        <li>
          No failure or delay in exercising any right, power, or privilege
          vested in the Bank by these conditions shall operate as a waiver
          thereof nor shall any partial exercise of such right, power, or
          privilege preclude any other or further exercise thereof.
        </li>
        <li>
          If any of the Conditions or provisions specified herein are invalid,
          illegal, or unenforceable in any respect under the law, the validity,
          legality, and enforceability of the remaining conditions and/or
          provisions contained herein shall not in any manner be affected or
          impaired thereby.
        </li>
        <li>
          Commission and charges shall be levied in accordance with the Bank's
          standard scale of charges in force from time to time and copies of
          which are available on request. The Bank reserves the right to amend
          its rates of profit share in accordance with its standard scale of
          charges and/or conditions from time to time.
        </li>
        <li>
          Where the conditions are signed by or on behalf of more than one
          person as the customer, all of such persons are bound by terms and
          conditions.
        </li>
        <li>
          Any communication by the Bank shall be deemed to have been made as
          soon as it is sent to the most-recent address provided by me/us and
          the date indicated on the duplicated copy of such letter or on the
          Bank's mailing list will constitute the date on which the
          communication was sent. Any statement of confirmation of any
          transaction between me/us or either of us and the Bank shall be deemed
          to have been examined by me/us and to be conclusive and binding unless
          within 10 working days from the date specified on such
          statement/confirmation, I/We or either of us advise the Bank in
          writing that an item contained therein is being disputed, whether or
          not such item was made in accordance with the mandate from time to
          time given by me/us to the Bank.
        </li>
        <li>
          I/We understand and acknowledge that electronic mail, facsimile, and
          verbal communications are insecure transmission media. Where I/We
          advise the Bank to accept the instruction in such manner, I/We,
          however, undertake to indemnify the Bank in full for any loss it may
          suffer or incur by reason of its honoring my/our letters, electronic
          mail, facsimile, or verbal instructions, irrespective of whether the
          same are erroneous, fraudulent, or issued otherwise than in accordance
          with the Mandate for my/our account(s). Any and all payment
          instructions issued in accordance with the Mandate for my/our
          account(s) which bear or purport to bear the facsimile or electronic
          mail signature of the person(s) whose specimen signatures have been
          provided to the Bank by me/us. The Bank is hereby authorized to honor
          and to debit my/our account for any and all payment
          instructions/confirmations issued or provided by me/us using a
          pre-agreed format for the same, which may include but is not limited
          to oral or written instructions/confirmations and where given orally
          such oral instructions may be previously agreed, involving the use of
          specific passwords, and when given in writing, may be given by letter,
          facsimile, or electronic mail.
        </li>
        <li>
          I/We hereby authorize the Bank to debit my/our account with the cost
          incurred in respect of the issuance of the cheque book(s) for the
          above account.
        </li>
        <li>
          Honor all cheques or other orders/instruments which may be drawn on
          the said account provided such cheques or orders/instruments are
          signed by me/us and to debit such cheques or orders/instruments to the
          said account in credit. I/We hereby agree:
          <ul className={styles.tncList}>
            <li>
              To assume full responsibility for the genuineness or correctness
              or validity of all endorsements appearing on all cheques, orders,
              bills, notes, negotiable instruments, receipts, and/or other
              documents deposited in my/our account.
            </li>
            <li>
              The Bank's rules and new rates as advised by the Bank from time to
              time.
            </li>
            <li>
              To free the Bank from any responsibility for any loss or damage of
              funds deposited with the Bank due to any future government order,
              law, tax, embargo, moratorium, exchange restriction, and/or all
              other causes beyond the Bank's control.
            </li>
            <li>
              That all funds standing to my/our credit are payable on demand
              only in such local currency as may be in circulation.
            </li>
            <li>
              To be bound by any notification of change in the conditions
              governing the account directed to my/our last known address, and
              any notice or letter sent to my/our last known address shall be
              considered as duly delivered and received by me/us at the time it
              would be.
            </li>
            <li>
              The Bank shall not be considered an agent or other legal
              representative of the customer for any purpose by reason of this
              agreement and/or any other party whom the customer is using his
              service to pay.
            </li>
            <li>
              This agreement cannot be changed by the customer nor any of the
              bank's rights waived unless the bank agrees in writing or the
              customer continues using the service following receipt of notice
              of any changes proposed by the bank.
            </li>
            <li>
              This agreement is personal to the customer and the customer shall
              not assign it to anyone.
            </li>
            <li>
              All notice to the customer shall be in writing via the address the
              customer has provided to the bank, all notices to the bank must be
              made in writing sent to the bank’s address.
            </li>
            <li>
              The bank and the customer shall be independent contractors, and
              nothing contained in this agreement shall be deemed to create any
              association, partnership, joint venture, or relationship of
              principal and agent or master and servant, employer, or employee
              between the parties.
            </li>
            <li>
              If any of these terms is held to be unenforceable, then such
              provision shall be construed, as nearly as possible, to reflect
              the intentions of the parties with the other provisions remaining
              in full force and effect.
            </li>
            <li>
              The Bank does not guarantee that access to the Service will be
              uninterrupted.
            </li>
            <li>
              The Bank may suspend or cancel access without notice if it
              suspects that the service or access is being used in an
              unauthorized or fraudulent manner.
            </li>
            <li>
              The customer may cancel the service at any time by notifying the
              Bank in writing.
            </li>
            <li>
              The laws of the Federal Republic of Nigeria shall apply to this
              agreement.
            </li>
          </ul>
        </li>
        <li>
          The Bank reserves the right to change or discontinue, temporarily or
          permanently, any service to maintain its security and integrity. In
          instances where such action is required for regulatory or security
          compliance, prior notice may not be provided. However, where
          permissible and to the extent possible, customers will be notified
          through agreed communication channels. The customer agrees that the
          Bank shall not be held liable for any modification or discontinuation,
          or for the absence of notice where it was not feasible.
        </li>
        <li>
          Credit Bureau: The customer acknowledges that the Bank consults with
          various credit bureaus and reference agencies and may be required to
          disclose the customer’s information to these credit bureaus for the
          purpose of conducting checks on the customer. The customer hereby
          irrevocably and unconditionally grants his/her/its consent to the Bank
          and expressly authorizes such disclosure of any or all information on
          his/her/its account(s)/transaction(s) with the Bank, to such credit
          bureau and reference agencies whether based locally or abroad,
          including information on the customer’s directors and other personnel,
          transactions and conduct on the customer’s account together with
          details of any non-payment or delayed payments as the Bank may deem
          necessary. The consent herein given discharges the Bank from all
          liabilities, claims, and damages for such disclosure made by the Bank
          to any credit bureau pursuant to the consent herein granted.
        </li>
      </ol>
      <p>
        In consideration of opening and maintaining an account with The
        Alternative NIB and the issuance of a debit card linked to the account,
        I/We hereby understand and agree as follows:
      </p>
      <ol className={`${styles.romanNumeralsList} ${styles.italics}`}>
        <li>
          The Bank does not seek any information relating to my/our full debit
          card PAN, CVV and Personal Identification Number (PIN), or other
          security information regarding my account or debit card.
        </li>
        <li>
          I/We are responsible for the security and safekeeping of my/our debit
          card, including my/our PIN, card PAN, etc.
        </li>
        <li>
          I/We shall not disclose any sensitive information regarding my/our
          account(s) or debit card to unauthorized parties through ant medium
          including but not limited to the internet, text messages, e-mail or
          telephone.
        </li>
        <li>
          I/We shall take all precautions to protect my/our account/debit card
          details to avoid any unauthorized use of the debit card or other
          account details.
        </li>
        <li>
          All transactions or actions initiated, authenticated and consummated
          on my/our account using the debit card are deemed initiated by me/ us.
        </li>
      </ol>
      <p className={styles.italics}>
        I/We, ......................................................... hereby
        irrevocably and unconditionally indemnify and keep the Bank fully
        indemnified against all claims, demands, liabilities, damages, loss,
        costs, charges, fees, expenses, distress, actions and proceedings which
        may be brought against the Bank or which the Bank may pay or incur in
        connection with or arising from any litigation or claim against the Bank
        in consequence of renewing and dispatching our debit card to me/us.
      </p>
      <h5>
        <strong>Customer’s Information </strong>
      </h5>
      <ul className={styles.tncList}>
        <li>
          I/We hereby apply for the opening of an account(s) with The
          Alternative Bank Plc. I/We understand that the information given
          herein and the documents supplied are the basis for opening such
          account(s), and hereby warrant that such information is correct. I/We
          further confirm that the account type and/or E-services was duly
          selected by me/us after due consideration of the Bank’s professional
          advice.
        </li>
        <li>
          I/We authorize The Alternative Bank Plc to disclose relevant account
          and/or personal information to the US tax authorities and other
          relevant tax authorities of jurisdictions where I am tax resident for
          the purpose of The Alternative Bank Plc complying with its obligations
          under the US Foreign Account Tax Compliance Act (FATCA) and/or Common
          Reporting Standard (CRS). I declare that I have examined the
          information on this form and to the best of my knowledge and belief,
          it is true, correct, and complete. If the information provided in this
          form changes, I undertake to provide The Alternative Bank with an
          updated self-certification and declaration within 30 days of such
          change.
        </li>
        <li>
          I/We, the undersigned applicant, warrant that the above information
          supplied by me/us is true and correct. I/We will undertake to fully
          cooperate with The Alternative Bank Plc to ensure it meets its
          obligations under FATCA and CRS in connection with my/our account.
        </li>
        <li>
          I/We will indemnify and hold harmless The Alternative Bank Plc from
          any loss, action, cost, expense (including, but not limited to sums
          paid in settlement of claims, reasonable attorneys’ and consultant
          fees, and expert fees), claim, damages, or liability which arises or
          is incurred by The Alternative Bank Plc as a result of false
          information or error in the information provided to the Bank, our
          choice of account, or in discharging its obligations under FATCA and
          CRS and/or as a result of disclosures to the US tax authorities and/or
          any other jurisdictions under the AEOI regime.
        </li>
      </ul>
      <h5>
        <strong>Data Capture & Usage</strong>
      </h5>
      <p className={styles.italics}>
        "By using our services, you consent to the collection, processing, and
        storage of your personal data, including biometric information where
        applicable. This data will be used solely for identity verification,
        security, regulatory compliance, and service improvement. We are
        committed to handling your information securely and in accordance with
        applicable data protection laws."
      </p>
    </>
  );
};

export default MainTandC;
